module.exports = __webpack_public_path__ + "img/Traps.c11f7dd4.png";